import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=16569485&scoped=true"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16569485",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16569485')) {
      api.createRecord('16569485', component.options)
    } else {
      api.reload('16569485', component.options)
    }
    module.hot.accept("./Campaigns.vue?vue&type=template&id=16569485&scoped=true", function () {
      api.rerender('16569485', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/parameters/Campaigns.vue"
export default component.exports